function xsrfTokenFromCookie() {
  const cookie = document.cookie
    .split(';')
    .find((c) => c.trim().startsWith('XSRF-TOKEN='));
  if (!cookie) {
    return null;
  }
  const cookieValue = cookie.split('=')[1];
  if (!cookieValue) {
    return null;
  }
  return decodeURIComponent(cookieValue);
}

export function addXSRFTokenToHeaders(headers) {
  const xsrfToken = xsrfTokenFromCookie();
  if (xsrfToken) {
    return {
      ...headers,
      'X-XSRF-TOKEN': xsrfToken,
    };
  }

  return headers;
}
